import CloseIcon from "@mui/icons-material/Close";

import type { ExternalWidgetBookingkit as ExternalWidgetBookingkitType } from "../../types/ExternalWidget";
import { ModalDeprecated, ModalLayout } from "../ModalDeprecated";
import { Bookingkit } from "./Bookingkit";

export type ExternalWidgetBookingkitContentProps = Omit<ExternalWidgetBookingkitType, "__typename"> & {
    open: boolean;
    onClose: () => void;
};

export function ExternalWidgetBookingkitContent({
    widgetId,
    subdomain,
    open,
    onClose,
}: ExternalWidgetBookingkitContentProps) {
    return (
        <>
            <ModalDeprecated open={open} keepMounted={true} onClose={onClose}>
                <ModalLayout header={<CloseIcon aria-label="close" color="primary" onClick={onClose} />}>
                    <Bookingkit widgetId={widgetId} subdomain={subdomain} />
                </ModalLayout>
            </ModalDeprecated>
        </>
    );
}
